import { Link } from "react-router-dom";

type BrandProps = {
  tone?: "dark" | "light";
  compact?: boolean;
  className?: string;
};

export function Brand({ tone = "dark", compact = false, className = "" }: BrandProps) {
  return (
    <Link
      to="/"
      className={`brand-lockup ${tone === "light" ? "brand-lockup-light" : ""} ${compact ? "brand-lockup-compact" : ""} ${className}`.trim()}
      aria-label="Triple H Real Estate & Construction — Home"
    >
      <img src="/brand/logo-mark.png" alt="" width="44" height="43" />
      <span className="brand-lockup-copy">
        <strong>Triple H</strong>
        <small>Real Estate &amp; Construction</small>
      </span>
    </Link>
  );
}
